import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoChevronBack } from "react-icons/io5";

import Logo from "../../../assets/logo_1.png";
import { Subscription } from "./Subscription";

/**
 * Standalone, full-screen plans page at /payment-plans.
 *
 * Rendered outside the dashboard shell so the content flows in normal
 * document flow — on mobile the whole page scrolls top-to-bottom (no nested
 * scroll panel) and every plan detail is reachable. Desktop keeps the
 * existing centered plan layout.
 */
export default function PaymentPlansPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/settings");
  };

  return (
    <div className="min-h-[100dvh] w-full bg-[#F5F6FA] flex flex-col">
      <header className="sticky top-0 z-20 flex items-center justify-between gap-3 px-4 py-3 border-b border-neutral-200 bg-white">
        <button
          type="button"
          onClick={goBack}
          className="flex items-center gap-1 text-sm font-medium text-[#020637] hover:opacity-80 transition-opacity px-1 py-1.5"
        >
          <IoChevronBack className="h-5 w-5" />
          {t("common.back", "Back")}
        </button>
        <img
          src={Logo}
          alt="Logo"
          className="h-7 w-auto object-contain"
        />
        <div className="w-14" aria-hidden="true" />
      </header>

      <div className="flex-1 w-full max-w-4xl mx-auto pb-10">
        <Subscription />
      </div>
    </div>
  );
}
